// extracted by mini-css-extract-plugin
module.exports = {"divLogo":"OrganizationForm_divLogo_L1h7t","logo":"OrganizationForm_logo_3kcti"};